import { APIGateway } from './api-gateway/api-gateway.ts';
import {
  API_POWER_BI_URL,
  API_REMOTE_SENSING_URL,
  BALANCE_URL,
  CORE_SERVICES_API_URL,
  NEMADIGITAL_CUP_API_URL,
  NEMADIGITAL_URL,
  OAUTH_CROPWISE_URL,
  PROTECTOR_API_URL,
  PROTECTOR_CROPWISE_API_URL
} from './config/constants.ts';
import { HttpClient } from './http-client/index.ts';

const createApiClient = (baseURL: string): APIGateway => new APIGateway(new HttpClient(baseURL));

export const balanceApiClient = createApiClient(BALANCE_URL);
export const coreServicesApiClient = createApiClient(CORE_SERVICES_API_URL);
export const nemaDigitalApiClient = createApiClient(NEMADIGITAL_URL);
export const nemaDigitalCupApiClient = createApiClient(NEMADIGITAL_CUP_API_URL);
export const oauthApiClient = createApiClient(OAUTH_CROPWISE_URL);
export const protectorApiClient = createApiClient(PROTECTOR_API_URL);
export const protectorCropwiseApiClient = createApiClient(PROTECTOR_CROPWISE_API_URL);
export const remoteSensingApiClient = createApiClient(API_REMOTE_SENSING_URL);
export const powerBIApiClient = createApiClient(API_POWER_BI_URL);
